export type TProductFilter =
  | Array<string | number | boolean | null | undefined>
  | string
  | number
  | boolean
  | null
  | undefined;

export type TGenericDatasetQueryParams = {
  page?: number;
  perPage?: number;
  searchText?: string;
  orderBy?: string;
  filters?: { [key: string]: TProductFilter };
  isActive?: boolean;
};

export type TProductCustomFieldOption = {
  id: string;
  name: string;
  color?: string;
};

export type TProductCustomField = {
  name: string;
  type: string;
  placeholder: string;
  maxLength: number;
  minLength: number;
  options?: TProductCustomFieldOption[];
};

export type TProductFilters = {
  [filterKey: string]: string[] | string | number | boolean | number[];
};

export type TBEGenricResponse<T> = {
  data: T;
};

export enum PRODUCT_TYPE {
  PhoneCase = 'PhoneCase',
}
